import { AssetMotionTab } from '../Motion';
import * as S from './TabMenu.styled';

interface TabMenuProps {
  selectedTab: AssetMotionTab;
  handleTabChange: (selectTab: AssetMotionTab) => void;
}

export default function TabMenu({
  selectedTab,
  handleTabChange,
}: TabMenuProps) {
  return (
    <S.Container>
      <S.Tab
        onClick={() => handleTabChange('BodyShape')}
        isActive={selectedTab === 'BodyShape'}
      >
        <span>Body shape</span>
      </S.Tab>
      <S.Tab
        onClick={() => handleTabChange('Clothes')}
        isActive={selectedTab === 'Clothes'}
      >
        <span>Clothes</span>
      </S.Tab>
      <S.Tab
        onClick={() => handleTabChange('Hair')}
        isActive={selectedTab === 'Hair'}
      >
        <span>Hair</span>
      </S.Tab>
    </S.Container>
  );
}
